
/**
 * Página de Cobrança
 * 
 * Wrapper da página de cobrança para integração com o sistema de rotas.
 * Esta página permite que os usuários gerenciem suas assinaturas,
 * vejam o status atual e escolham novos planos.
 */

import BillingPage from '@/components/billing/BillingPage';

const BillingPageWrapper = () => {
  return <BillingPage />;
};

export default BillingPageWrapper;
